import * as React from "react"
import type { LayoutBuilderAction } from "src/frontend/components/Shared/Layout/actions"
import { type LayoutBuilderState } from "src/frontend/components/Shared/Layout/types"

interface LayoutContextValue {
  state: LayoutBuilderState
  dispatch: React.Dispatch<LayoutBuilderAction>
}

export const LayoutContext = React.createContext<LayoutContextValue | null>(null)

interface LayoutProviderProps {
  reducer: (state: LayoutBuilderState, action: LayoutBuilderAction) => LayoutBuilderState
  initialState: LayoutBuilderState
}

export const LayoutProvider: React.FC<React.PropsWithChildren<LayoutProviderProps>> = ({
  reducer,
  initialState,
  children,
}) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)

  const value = React.useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state, dispatch]
  )

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
}
